<template>
  <div class="main-container">
    <div class="summary-box">
      <!--<p class="summary-title">{{ title }}</p>-->
      <div class="container-content p-4">
        <CRow v-for="(item, index) in answer" :key="index" class="m-2">
        
          <CCol class="col-3 text-center">
            <div class="img-thumb"></div>
          </CCol>
          <CCol class="col-9 text-left" 
          :class="{'answer-right':item.correct , 'answer-wrong': !item.correct}"
        
          >
            <h4 class="mt-3">{{item.question}}</h4>
            <div class="text-center">
              <p class="answer p-1">{{item.answer}}</p>
            </div>
          </CCol>
        </CRow>
      </div>
    </div>

    <div class="button-container mt-4">
      <button class="button btn-primary" type="button" @click.prevent="onSummary()">ต่อไป</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Summary",
  props: {
    nextChapterInfo: String,
  },
  data() {
    return {
      answer: [],
    };
  },

  created() {
    this.answer = this.$store.getters["progress/getUserProgress"];
  },
  methods: {},
};
</script>

<style scoped>
@import "../../assets/scss/CPR/style.scss";
.answer {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #fff;
}
.answer-wrong {
  background: #FF8888;
  background: linear-gradient(
    90deg,
    rgba(255, 136, 136, 0.8) 0%,
    rgba(255, 136, 136, 0.2) 100%
  );
}
.answer-wrong .answer {
  background: #FF8888;
  color: #FFF;
}
.answer-right {
  background: rgb(56, 173, 174);
  background: linear-gradient(
    90deg,
    rgba(56, 173, 174, 0.8) 0%,
    rgba(169, 241, 223, 0.2) 100%
  );
}
.answer-right .answer {
  background: #a9f1df;
}
.img-thumb {
  border: 1px solid #a9f1df;
  width: 100px;
  height: 100px;
  display: inline-block;
  border-radius: 10px;
  -webkit-box-shadow: 4px 4px 10px 1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 10px 1px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 10px 1px rgba(0, 0, 0, 0.75);
}
.cartoon-image-container {
  position: absolute;
  /* left: 5rem;
  bottom: 20rem; */
  left: 5rem;
  bottom: 0rem;
  width: 16rem;
  height: 24rem;
}

.cartoon-image-container img {
  object-fit: fill;
  width: 100%;
  height: 100%;
  max-width: auto;
  max-height: auto;
}

.button-container {
  text-align: center;
}

.button-container .button {
  outline: none;
  padding: 1rem 3rem;
}

.main-container {
  /* overflow: hidden; */
  overflow: hidden;
  padding-top: 6.875rem;
  left: 0px;
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: auto;
  /* background: transparent linear-gradient(224deg, #ffffff00 0%, #00000038 100%)
    0% 0% no-repeat padding-box; */
    background: #f3f3f3;
}

.main-container .summary-box {
  /* top: 228px; */
  /* left: 364px; */
  /* display: flex;
  justify-content: center; */
  text-align: center;
  margin: auto;
  width: 44.5rem;
  /*height: 27.8125rem;*/
  height: auto;
  box-shadow: -8px -8px 20px #a9f1df;
  border: 4px solid #ffffff33;
  border-radius: 30px;
  opacity: 1;
}

.main-container .summary-box .cancel-mark {
  float: right;
  margin-right: -1.25rem;
  font-size: 1.35rem;
  margin-top: -1.25rem;
}

.main-container .summary-box .cancel-mark:hover {
  cursor: pointer;
}

.main-container .summary-box .summary-title {
  margin-bottom: 5.6875rem;
  margin-top: 2.625rem;
  text-align: center;
  font-size: 30px;
  letter-spacing: 0px;
  color: #38adae;
  opacity: 1;
}

.main-container .summary-box .container-content {
  padding: 0px 4.5625rem;
}

.main-container .summary-box .status-circle-display {
  margin-top: 0.4375rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: auto;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: transparent
    linear-gradient(312deg, #f2f2f2 0%, #eaeaea 27%, #b2b2b2 92%, #797979 100%)
    0% 0% no-repeat padding-box;
  border: 4px solid #f2f2f2;
  opacity: 1;
}
</style>